import { P } from '../../theme/tokens';

export const STATUS = {
  preferred: { label: 'Preferred', color: P.success },
  active: { label: 'Active', color: P.info },
  on_call: { label: 'On call', color: P.danger },
  contract: { label: 'Contract', color: P.purple },
  insurance_expiring: { label: 'Insurance expiring', color: P.warning },
  inactive: { label: 'Inactive', color: P.subtle }
};

export const STATUS_OPTIONS = Object.entries(STATUS).map(([value, s]) => ({ value, label: s.label }));

export const TRADES = [
  'HVAC',
  'Plumbing',
  'Electrical',
  'Roofing',
  'Appliance',
  'Water / Fire',
  'Turns & Paint',
  'Pest Control',
  'Landscaping',
  'General'
];

export const SORTS = [
  { value: 'company', label: 'Company A–Z' },
  { value: '-company', label: 'Company Z–A' },
  { value: 'trade', label: 'Trade' },
  { value: 'status', label: 'Status' },
  { value: '-createdAt', label: 'Newest' }
];

export const statusOf = (key) => STATUS[key] || STATUS.active;

export function formatResponse(mins) {
  if (mins == null) return null;
  if (mins < 60) return `${mins}m`;
  const days = Math.floor(mins / 1440);
  const hours = Math.floor((mins % 1440) / 60);
  if (days) return hours ? `${days}d ${hours}h` : `${days}d`;
  const rest = mins % 60;
  return rest ? `${hours}h ${String(rest).padStart(2, '0')}m` : `${hours}h`;
}
